import { useConnection } from 'modules/auth';
import { getValidChain,  TChainId } from 'modules/api';

export const useValidChainId = (): TChainId => {
  const { chainId: currentChainId } = useConnection();

  const chainId = getValidChain(currentChainId);

  return chainId;
};
